/**
 * useControllerEvents — declarative event registration/teardown helper.
 *
 * Instead of 78+ lines of manual `.on()` / `.removeEventListener()` boilerplate
 * in mounted/beforeUnmount, pass an array of [controller, eventName, handler]
 * and call the returned cleanup function on unmount.
 *
 * Compatible with CallsController, RoomController, ChatController (static on/removeEventListener).
 */

export type EventController = {
    on(event: string, listener: (...args: any[]) => void): void;
    removeEventListener(event: string, listener: (...args: any[]) => void): void;
};

export type EventEntry = [EventController, string, (...args: any[]) => void];

/**
 * Register all event listeners and return a cleanup function to remove them.
 */
export function useControllerEvents(entries: EventEntry[]): () => void {
    for (const [ctrl, event, handler] of entries) {
        ctrl.on(event, handler);
    }
    return () => {
        for (const [ctrl, event, handler] of entries) {
            ctrl.removeEventListener(event, handler);
        }
    };
}
